import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../service/api.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {


  constructor(private router: Router,private apiService: ApiService) { 
      
  }

  ngOnInit(): void {
  }
redirect() {
         this.apiService.setLoggedIn(false);
         sessionStorage.clear();
        this.router.navigate(['']);
        return;

}
}
